<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <div v-if="$gate.isSysAdmin()">
            <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h2>Stock | Master</h2>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">
                                    <a href="/home">Home</a>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ $route.meta.title }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <!-- /.container-fluid -->
            </section>

            <!-- Main content -->
            <section class="content">
                <br />
                <!-- main row for all icons  -->
                <div class="col-lg-12">
                    <div class="col-lg-10 center center-block" align="center">
                        <div class="card card-danger card-outline">
                            <div class="card-header">
                                <button
                                    @click="sync"
                                    class="btn btn-danger float-right"
                                >
                                    Sync Stock
                                </button>
                            </div>
                            <div class="card-body overflow-auto">
                                <div class="col-md-10 float-left">
                                    <div class="row">
                                        <div class="col-sm-4 float-left">
                                            <div class="form-group">
                                                <input
                                                    type="number"
                                                    class="form-control"
                                                    min="5"
                                                    value="10"
                                                    v-model="results"
                                                    placeholder="Enter No. of results"
                                                    @input="
                                                        getStock(
                                                            '/api/getStock'
                                                        )
                                                    "
                                                />
                                            </div>
                                            <div class="form-group float-left">
                                                <button
                                                    class="btn btn-danger"
                                                    @click="
                                                        getStock(
                                                            '/api/getStock'
                                                        )
                                                    "
                                                >
                                                    <i class="fa fa-search"></i>
                                                    Search
                                                </button>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <v-select
                                                    v-model="branch"
                                                    type="text"
                                                    label="branch"
                                                    :options="branches"
                                                    :reduce="
                                                        (branches) =>
                                                            branches.branch_code
                                                    "
                                                    name="branch"
                                                    placeholder="Select Branch"
                                                    :value="
                                                        (branches) =>
                                                            branches.branch_code
                                                    "
                                                ></v-select>
                                            </div>
                                            <div class="form-group float-left">
                                                <button
                                                    class="btn btn-danger"
                                                    @click="reset"
                                                >
                                                    <i class="fa fa-times"></i>
                                                    Reset
                                                </button>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group float-left">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="name"
                                                    placeholder="Enter a name"
                                                />
                                            </div>
                                            <div class="form-group float-left">
                                                <button
                                                    class="btn btn-secondary"
                                                    @click="excel"
                                                >
                                                    <i class="fa fa-print"></i>
                                                    Generate Excel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <img v-if="stocks == ''" src="" />
                                <datatable
                                    style="margin-top: 1%"
                                    :columns="columns"
                                    v-else
                                >
                                    <tbody>
                                        <tr
                                            v-for="stock in stocks"
                                            :key="stock.id"
                                        >
                                            <td>{{ stock.ITEM_NAME }}</td>
                                            <td>{{ stock.BRANCH_NAME }}</td>
                                            <td>{{ stock.SALEABLE_STOCK }}</td>
                                            <td>
                                                <button
                                                    class="btn btn-danger"
                                                    @click="view(stock)"
                                                >
                                                    <i class="fa fa-eye"></i>
                                                    View More
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </datatable>
                                <!-- content here -->
                            </div>
                            <div class="card-footer">
                                <pagination
                                    :pagination="pagination"
                                    @prev="getStock(pagination.prevPageUrl)"
                                    @next="getStock(pagination.nextPageUrl)"
                                ></pagination>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- row end -->
            </section>
            <!-- /.content -->
            <div class="modal" tabindex="-1" role="dialog" id="viewModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Stock Details</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p><b>Item Code:</b> {{ form.ITEM_CODE }}</p>
                            <p><b>Item Name:</b> {{ form.ITEM_NAME }}</p>
                            <p><b>Branch Name:</b> {{ form.BRANCH_NAME }}</p>
                            <p><b>Branch Code:</b> {{ form.BRANCH_CODE }}</p>
                            <p>
                                <b>Saleable Stock:</b> {{ form.SALEABLE_STOCK }}
                            </p>
                            <p>
                                <b>Non-Saleable Stock:</b>
                                {{ form.NONSALEABLE_STOCK }}
                            </p>
                            <p><b>Saleable Git:</b> {{ form.SALEABLE_GIT }}</p>
                            <p>
                                <b>Non-Saleable Git:</b>
                                {{ form.NONSALEABLE_GIT }}
                            </p>
                            <p>
                                <b>Saleable DC Git:</b>
                                {{ form.SALEABLE_DC_GIT }}
                            </p>
                        </div>
                        <div class="card-footer">
                            <button
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isSysAdmin()">
            <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
import Datatable from "../../datatable.vue";
import Pagination from "../../pagination.vue";
import { saveAs } from "file-saver";
import loading from "vue-full-loading";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { datatable: Datatable, pagination: Pagination, loading },

    created() {
        this.getBranches();
        this.getStock();
    },

    data() {
        let columns = [
            { width: "25%", label: "Name", name: "ITEM_NAME" },
            { width: "25%", label: "Branch", name: "BRANCH_NAME" },
            { width: "25%", label: "Stock", name: "SALEABLE_STOCK" },
            { width: "25%", label: "View More", name: "ops" },
        ];

        return {
            columns: columns,
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
            stocks: [],
            results: "",
            branch: "",
            branches: [],
            name: "",
            form: new Form({
                ITEM_CODE: "",
                ITEM_NAME: "",
                BRANCH_CODE: "",
                BRANCH_NAME: "",
                SALEABLE_STOCK: "",
                NONSALEABLE_STOCK: "",
                SALEABLE_GIT: "",
                NONSALEABLE_GIT: "",
                SALEABLE_DC_GIT: "",
            }),
            lshow: false,
            llabel: "Syncing. Do not close or change this page...",
        };
    },

    methods: {
        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },

        getStock(url = "/api/getStock") {
            axios
                .post(url, {
                    results: this.results,
                    branch: this.branch,
                    name: this.name,
                })
                .then((response) => {
                    this.stocks = response.data.data.data;
                    this.configPagination(response.data.data);
                });
        },

        view(stock) {
            this.form.fill(stock);
            $("#viewModal").modal("show");
        },

        excel() {
            axios({
                url: "/api/stocksExcel",
                data: { city: this.city },
                method: "post",
                responseType: "blob",
            }).then((response) => {
                toast.fire({
                    icon: "success",
                    title: "Report Generated",
                });
                var blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });

                var name = "";
                if (this.name != "") name = name + this.name + "_";
                if (this.branch != "") name = name + this.branch + "_";

                saveAs(response.data, name + "stock.xlsx");
            });
        },

        sync() {
            toast.fire({
                icon: "warning",
                title: "Wait For Syncing to be Over",
            });
            this.lshow = true;
            axios
                .post("/api/syncStock")
                .then((response) => {
                    toast.fire({
                        title: response.data + " Items Synced",
                        type: "success",
                    });
                    this.getStock();
                    this.lshow = false;
                })
                .catch(() => {
                    toast.fire({
                        title: "Syncing Failed! Try Again.",
                        type: "error",
                    });
                });
        },

        reset() {
            this.results = "";
            this.branch = "";
            this.name = "";
        },

        getBranches() {
            axios.post("/api/getBranches").then((response) => {
                this.branches = response.data;
            });
        },
    },
};
</script>
